import { updateCampaigns } from 'actions/campains'
import {
  getBulkMediumAffectedCampaignNames,
  getBulkMediumUpdateCategories
} from 'features/ManageCampaigns/utils/inviteBulkMediumHelpers'
import inviteEmailDesignApi from 'services/api/inviteEmailDesign'
import { useDispatch } from 'react-redux'
import { useToasts } from 'react-toast-notifications'

import { resolveInviteEmailDesignApplyScope } from './inviteEmailDesignApplyHelpers'

const useInviteEmailDesignApply = ({ campaigns, contentSubsidiaryId }) => {
  const dispatch = useDispatch()
  const { addToast } = useToasts()

  function getAffectedCampaignNames(scope) {
    return getBulkMediumAffectedCampaignNames(campaigns, scope)
  }

  function validateScope(scope) {
    const categories = getBulkMediumUpdateCategories(scope)
    if (!categories.length) {
      addToast('No eligible campaigns in this scope.', { appearance: 'warning' })
      return false
    }

    return true
  }

  function applyTemplateToScope({ templateId, scope }) {
    if (!templateId || !validateScope(scope)) {
      return Promise.reject(new Error('Invalid apply request'))
    }

    return inviteEmailDesignApi
      .applyTemplate({
        templateId,
        scope: resolveInviteEmailDesignApplyScope(scope)
      })
      .then(appliedCount => {
        dispatch(updateCampaigns(contentSubsidiaryId))

        if (typeof appliedCount !== 'number') {
          addToast('Apply completed but the campaign count was unavailable.', {
            appearance: 'warning'
          })
          return appliedCount
        }

        if (appliedCount === 0) {
          addToast('No campaigns were updated. Check that eligible campaigns exist for this scope.', {
            appearance: 'warning'
          })
          return appliedCount
        }

        addToast(`Applied email template to ${appliedCount} campaign(s).`, {
          appearance: 'success'
        })
        return appliedCount
      })
      .catch(error => {
        const apiMessage = error?.message?.replace(/\s+from\s+content\/invite-email-design\/apply$/i, '')
        addToast(apiMessage || 'Failed to apply email template.', { appearance: 'error' })
        throw error
      })
  }

  return {
    applyTemplateToScope,
    getAffectedCampaignNames,
    validateScope
  }
}

export default useInviteEmailDesignApply
